// Story 8.10 (ADO-2019), Q4: "Already added" (the 8.10 Figma exports, "Q4 · Already added by
// someone else"), shown when the order the Shopper is on was accepted already: after an accept
// that lost the race (the typed 409, nothing was added again) or when an accepted order's page
// is opened. The title keeps "Review handheld order" with a green "Added" pill; an info box
// (the /choose card's tinted look) says who added it and when, in the viewer's zone (DV-38),
// with the date when it was not today; then "Go to carts" (to /choose, where the open carts
// are) and "Back to HHT Orders". With no name to show the sentence leaves it out.
import { Link } from 'react-router';
import { Icon } from '../../design-system';
import type { HhtOrderAlreadyAccepted } from '../../api/hht-orders.client';
import { CHOOSE_ROUTE } from '../../ordering/orderingChoices';
import { formatTimeWithDateUnlessToday } from '../../shared/datetime';
import { HhtPill } from './HhtPill';
import { HHT_ORDERS_ROUTE } from './hhtRoutes';
import linkButton from '../Cart/LinkButton.module.css';
import styles from './HhtOrders.module.css';

export function HhtAlreadyAdded({
  accepted,
  nowMs,
}: {
  readonly accepted: HhtOrderAlreadyAccepted;
  /** Today, for whether the date is needed. */
  readonly nowMs: number;
}) {
  const when = formatTimeWithDateUnlessToday(accepted.acceptedAt, nowMs);
  const who =
    accepted.acceptedByName === null
      ? `This order was added to carts at ${when}.`
      : `${accepted.acceptedByName} added this order to carts at ${when}.`;
  return (
    <>
      <div className={styles.head}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>Review handheld order</h1>
          <HhtPill tone="success">Added</HhtPill>
        </div>
        <p className={styles.subtitle}>This HHT order has already been processed.</p>
      </div>
      <section className={styles.infoBox} aria-labelledby="hht-already-added-title">
        <Icon name="info" size={18} className={styles.infoBoxIcon} />
        <p id="hht-already-added-title" className={styles.infoBoxTitle}>
          Already added to carts
        </p>
        <p className={styles.infoBoxLine}>{who} Nothing was added again.</p>
      </section>
      <div className={styles.alreadyAddedActions}>
        <Link to={CHOOSE_ROUTE} className={`${linkButton.linkButton} ${linkButton.primary}`}>
          Go to carts
        </Link>
        <Link to={HHT_ORDERS_ROUTE} className={`${linkButton.linkButton} ${linkButton.secondary}`}>
          Back to HHT Orders
        </Link>
      </div>
    </>
  );
}
